/**
 * AngularJS interceptor to add X-Account-Id header to API requests
 * Reads current accountId from sessionStorage and adds to all /api/ and /odata/ requests
 */

(function () {
    'use strict';

    angular
        .module('App.v1')
        .factory('accountContextInterceptor', accountContextInterceptor)
        .config(configureInterceptor);

    configureInterceptor.$inject = ['$httpProvider'];
    function configureInterceptor($httpProvider) {
        $httpProvider.interceptors.push('accountContextInterceptor');
    }

    accountContextInterceptor.$inject = ['$window'];
    function accountContextInterceptor($window) {
        var service = {
            request: request
        };

        return service;

        function request(config) {
            // Only add header to API and OData requests
            if (config.url && (config.url.indexOf('/api/') !== -1 || config.url.indexOf('/odata/') !== -1)) {
                // Get accountId from sessionStorage
                var accountId;

                // Try to get from ViewBag (set server-side via Finbuckle MultiTenant)
                if (typeof ViewBag !== 'undefined' && ViewBag.tenantId) {
                    accountId = ViewBag.tenantId;
                }

                // Add X-Account-Id header if we have an accountId
                if (accountId) {
                    config.headers = config.headers || {};
                    config.headers['X-Account-Id'] = accountId;
                }
            }

            return config;
        }
    }
})();
